import { render, staticRenderFns } from "./people-header.vue?vue&type=template&id=5811528e"
import script from "./people-header.vue?vue&type=script&lang=ts"
export * from "./people-header.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports